<template>
  <div class="dashboard">
    <div class="title">数据统计📊</div>
    <Hits></Hits>
    <div class="click-all">
      <clickNum></clickNum>
      <api-in-dash></api-in-dash>
    </div>
  </div>
</template>

<script>
import clickNum from "@/components/User/Dashboard/ClickNum.vue";
import Hits from "@/components/User/Dashboard/Hits.vue";
import ApiInDash from "@/components/User/Dashboard/ApiInDash.vue";
export default {
  name: "dashboard",
  components: {
    clickNum,
    Hits,
    ApiInDash,
  },
  props: {},
};
</script>
<style lang="less" scoped>
.dashboard {
  .title {
    font-size: 1.5rem;
    margin: 1rem;
  }
  .click-all {
    display: flex;
    align-items: center;
  }
}
</style>